import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "exportProductEPCGItemSnoPartC",
          label: "Item SNo Part C",
          component: "text-field",
          icon: LuSearch,
          required : true
        },
         {
          name: "exportProductEPCGItemType",
          label: "Item type",
          component: "dropdown",
          endIconName: "LuChevronDown",
          options: [
            { label: "Imported", value: "Imported" },
            { label: "Indigenous", value: "Indigenous" }
          ],
        },
      ],
      row2: [
        {
          name: "exportProductEPCGItemDescription",
          label: "Description",
          component: "text-field",
        },
      ],
      row3:[
        {
          name: "exportProductEPCGItemQuantity",
          label: "Quantity",
          component: "text-field",
          dataType: "int",
        },
        {
          name: "exportProductEPCGItemUnit",
          label: "Unit",
          component: "text-field",
          type : "autocomplete",
          endpoint: "getQuantity",
        },
      ]
    },
  },
]
};
